"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtPrint = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtPrint = function SvgBtPrint(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.8431 9.27959H18.4319V8.36435C18.4319 7.06114 17.3708 6 16.0676 6H11.1034C9.80021 6 8.73907 7.06114 8.73907 8.36435V9.27959H8.36435C7.06114 9.27959 6 10.3407 6 11.6439V15.4574C6 16.7606 7.06114 17.8218 8.36435 17.8218H8.73575V20.8195C8.73575 21.4694 9.26632 22 9.91627 22H17.2481C17.898 22 18.4286 21.4694 18.4286 20.8195V17.8218H18.8431C20.1463 17.8218 21.2075 16.7606 21.2075 15.4574V11.6439C21.2075 10.3407 20.1463 9.27959 18.8431 9.27959ZM9.63109 8.36435C9.63109 7.55523 10.291 6.89534 11.1001 6.89534H16.0609C16.8701 6.89534 17.5299 7.55523 17.5299 8.36435V9.27959H9.63109V8.36435ZM17.5333 20.8261C17.5333 20.982 17.4039 21.1113 17.2481 21.1113H9.91627C9.76041 21.1113 9.63109 20.982 9.63109 20.8261V15.8819H17.5333V20.8261ZM20.3121 15.4607C20.3121 16.2698 19.6522 16.9297 18.8431 16.9297H18.4319V15.8819H19.0222C19.2709 15.8819 19.4698 15.6829 19.4698 15.4342C19.4698 15.1855 19.2709 14.9865 19.0222 14.9865H8.07917C7.83047 14.9865 7.6315 15.1855 7.6315 15.4342C7.6315 15.6829 7.83047 15.8819 8.07917 15.8819H8.73907V16.9297H8.36435C7.55523 16.9297 6.89534 16.2698 6.89534 15.4607V11.6473C6.89534 10.8381 7.55523 10.1782 8.36435 10.1782H18.8431C19.6522 10.1782 20.3121 10.8381 20.3121 11.6473V15.4607Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.7152 18.0838H16.4156C16.6643 18.0838 16.8632 17.8848 16.8632 17.6361C16.8632 17.3874 16.6643 17.1885 16.4156 17.1885H10.7152C10.4665 17.1885 10.2676 17.3874 10.2676 17.6361C10.2676 17.8848 10.4699 18.0838 10.7152 18.0838Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.452 19.019H10.7484C10.4997 19.019 10.3007 19.218 10.3007 19.4667C10.3007 19.7154 10.4997 19.9144 10.7484 19.9144H16.4487C16.6974 19.9144 16.8964 19.7154 16.8964 19.4667C16.8964 19.218 16.6974 19.019 16.452 19.019Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.8335 11.0371H17.9249C17.6762 11.0371 17.4772 11.2361 17.4772 11.4848C17.4772 11.7335 17.6762 11.9324 17.9249 11.9324H18.8335C19.0822 11.9324 19.2812 11.7335 19.2812 11.4848C19.2812 11.2361 19.0822 11.0371 18.8335 11.0371Z",
    fill: "currentColor"
  }));
};

exports.SvgBtPrint = SvgBtPrint;